import { createFileRoute, redirect } from "@tanstack/react-router";
import { authClient } from "@/auth";
import { CheckoutReturnPage } from "@/pages/checkout/CheckoutReturnPage";

export const Route = createFileRoute("/checkout-return")({
	beforeLoad: async () => {
		const { data: authSession } = await authClient.getSession();

		if (!authSession?.user) {
			throw redirect({ to: "/auth/signin" });
		}

		return { authSession };
	},
	head: () => ({
		meta: [{ title: "Completing subscription - BitEasy" }],
	}),
	component: CheckoutReturnPage,
});
